import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import PWAInstallPrompt from '../components/features/PWAInstallPrompt';

const Contact = () => {
  return (
    <div style={{
      minHeight: '100vh',
      position: 'relative',
      background: 'radial-gradient(ellipse at center, #1a1a2e 0%, #16213e 50%, #0f0f23 100%)',
      color: 'white',
      overflow: 'hidden'
    }}>
      <div style={{
        position: 'relative',
        zIndex: 10,
        padding: window.innerWidth <= 768 ? '20px 16px' : '20px',
        width: '100%',
        boxSizing: 'border-box',
        overflowX: 'hidden'
      }}>
        <div style={{ 
          maxWidth: '1280px', 
          margin: '0 auto',
          width: '100%',
          boxSizing: 'border-box'
        }}>
          {/* Featured Image */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, delay: 0.4 }}
            style={{
              textAlign: 'center',
              marginBottom: '12px',
              paddingTop: '20px'
            }}
          >
            <img
              src="/favicon.png"
              alt="Rainbow Sails"
              style={{
                width: '25%',
                maxWidth: '200px',
                height: 'auto',
                margin: '0 auto'
              }}
            />
          </motion.div>

          {/* Header */}
          <header style={{ textAlign: 'center', marginBottom: '64px' }}>
            <motion.h1 
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              style={{
                fontSize: 'clamp(3rem, 8vw, 5rem)',
                fontWeight: 'bold',
                marginBottom: '24px',
                color: '#10b981'
              }}
            >
              Contact Us
            </motion.h1>
            <motion.p 
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              style={{
                fontSize: 'clamp(1.25rem, 3vw, 1.875rem)',
                color: '#22d3ee',
                marginBottom: '16px'
              }}
            >
              💬 Get in Touch • 🚀 Support • 🌈 Join the Community
            </motion.p>
          </header>

          {/* Contact Information Section */}
          <section style={{ marginBottom: '64px' }}>
            <motion.div 
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              style={{
                background: 'linear-gradient(135deg, rgba(139, 92, 246, 0.5), rgba(236, 72, 153, 0.5))',
                backdropFilter: 'blur(4px)',
                borderRadius: '12px',
                padding: '32px',
                border: '2px solid #10b981'
              }}
            >
              <h2 style={{ fontSize: '2.25rem', fontWeight: 'bold', marginBottom: '24px', color: '#10b981' }}>📧 Contact Information</h2>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                <div>
                  <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '12px', color: '#4ade80' }}>Email Support</h3>
                  <p style={{ fontSize: '18px', color: '#d1d5db', lineHeight: '1.6' }}>
                    For all inquiries, support, and questions: <strong style={{ color: '#f59e0b' }}>support@rainbow-sails.shop</strong>
                  </p>
                </div>
                <div>
                  <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '12px', color: '#4ade80' }}>Response Time</h3>
                  <p style={{ fontSize: '18px', color: '#d1d5db', lineHeight: '1.6' }}>
                    We typically respond within 24 hours during business days. For urgent matters, 
                    please mention "URGENT" in your subject line.
                  </p>
                </div>
              </div>
            </motion.div>
          </section>

          {/* Call to Action Section */}
          <section style={{
            textAlign: 'center',
            background: 'linear-gradient(135deg, rgba(236, 72, 153, 0.2), rgba(139, 92, 246, 0.2))',
            borderRadius: '12px',
            padding: '32px',
            border: '2px solid #a78bfa'
          }}>
            <motion.h2 
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
              style={{
                fontSize: '2.25rem',
                fontWeight: 'bold',
                marginBottom: '16px',
                color: '#a78bfa'
              }}
            >
              Ready to Explore? 🌈
            </motion.h2>
            <motion.p 
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.7 }}
              style={{
                fontSize: '20px',
                marginBottom: '24px',
                maxWidth: '48rem',
                margin: '0 auto 24px'
              }}
            >
              Have questions about our consciousness-expanding art? Need help with an order? 
              We're here to help you on your journey!
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.8 }}
            >
              <Link
                to="/gallery"
                style={{
                  display: 'inline-block',
                  background: 'linear-gradient(135deg, #ec4899, #8b5cf6)',
                  color: 'white',
                  padding: '16px 32px',
                  borderRadius: '8px',
                  fontWeight: '600',
                  fontSize: '20px',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'linear-gradient(135deg, #db2777, #7c3aed)';
                  e.target.style.transform = 'scale(1.05)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'linear-gradient(135deg, #ec4899, #8b5cf6)';
                  e.target.style.transform = 'scale(1)';
                }}
              >
                🚀 Explore the Gallery
              </Link>
            </motion.div>
            <p style={{ fontSize: '14px', color: '#9ca3af', marginTop: '16px' }}>
              AI-crafted art • Premium quality • Worldwide shipping • 24/7 support
            </p>
          </section>
        </div>
      </div>
      <PWAInstallPrompt />
    </div>
  );
};

export default Contact;
